import React, { useContext, useMemo } from "react"
import { Breadcrumbs } from "../../../mp-shared-components/ready-shared-components/components"
import { EocRouteParams } from "../../study-plans/types"
import { getRoutePathnames } from "../../study-plans/helpers"
import { ProgramsContext } from "../../../mp-shared-components/ready-shared-components/components/Navs"
import { User } from "../../../mp-database"
import { GlobalMachineContext } from "../../study-plans/pages/StudyPlansInit/StudyPlansInit"

interface Props {
  user: User
}

const StudyPlanBreadcrumbs: React.FC<Props> = ({ user }) => {
  const { currentProgram } = useContext(ProgramsContext)

  const { send } = GlobalMachineContext.useActorRef()
  const { availableCourses } = GlobalMachineContext.useSelector(state => ({
    availableCourses: state.context.availableCourses
  }))

  const routesPathnames = useMemo(
    () => getRoutePathnames(currentProgram, availableCourses, user.role),
    [user.role, availableCourses]
  )

  const onGuardedRouteExit = () => {
    // Simply send CANCEL - the state machine will handle navigation
    console.log("HERE guard rout on breadcrumbs")
    send({ type: "CANCEL" })
  }

  return (
    <Breadcrumbs<EocRouteParams>
      routesPathnames={routesPathnames}
      baseUrl={`eoc/${currentProgram || "staar"}`}
      homeUrl={`/eoc/${currentProgram || "staar"}/dashboard`}
      guardedActionsMap={{ Edit: onGuardedRouteExit }}
    />
  )
}

export default StudyPlanBreadcrumbs
